import React from 'react'
import { propType } from 'graphql-anywhere'
import classnames from 'classnames'

import CALL_FOR_ACTION_FRAGMENT from '../../../graphql/fragments/call-for-action.gql'
import EmailBox from '../shared/emailBox'

import { useStyles } from './callForAction.styles'

/*
* CallForActionComponent displays a call-to-action section on logged out home page, the component includes
* a header, description, email input box, styled conditionally based on styleType (SVOD or TVOD).
* User will be navigated to the login modal or sign-up flow based on the email validation.
*/

function CallForActionComponent({ callForAction }) {
  const styles = useStyles()
  const isTVOD = callForAction.styleType === 'TVOD'

  return (
    <div className={classnames(styles.container, isTVOD && styles.tvodContainer)}>
      <div className={styles.content}>
        {callForAction.header && (
          <p className={styles.header}>
            {callForAction.header}
          </p>
        )}

        {callForAction.description && (
          <p className={styles.description}>
            {callForAction.description}
          </p>
        )}

        { callForAction.buttonText && <EmailBox buttonText={callForAction.buttonText} inputText={callForAction.inputText} isTVOD={isTVOD} /> }
      </div>
    </div>
  )
}

CallForActionComponent.propTypes = {
  callForAction: propType(CALL_FOR_ACTION_FRAGMENT).isRequired
}

export default CallForActionComponent
